export default "/assets/Icon/WalletOutline.svg"